import loaderVideo from "../assets/group-33.mp4";

const Loader = () => {
  return (
    <div className="loader-overlay">
      <video autoPlay loop muted playsInline className="loader">
        <source src={loaderVideo} type="video/mp4" />
        <div className="fallback-loader"></div>
      </video>
    </div>
  );
};

export default Loader;
